import type { FC } from 'react';

import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Box, Stack, Text } from '@eneco/sparky';
import { Usages_Reading_MeterModel } from '@monorepo-types/dc';

export type MeterDetailsProps = {
  meterNumber: Usages_Reading_MeterModel['meterNumber'];
  meterValue: string;
  meterType?: string;
};

export const MeterDetails: FC<MeterDetailsProps> = props => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/MeterDetails.${label}.${locale}.json`)}>
      <MeterDetailsComponent {...props} />
    </I18nProvider>
  );
};

const MeterDetailsComponent: FC<MeterDetailsProps> = ({ meterNumber, meterType, meterValue }) => {
  const { t } = useTranslation();

  return (
    <Box borderRadius="s" padding="4" backgroundColor="feedbackBackgroundInfo">
      <Stack direction={{ initial: 'column', md: 'row' }} gap={{ initial: 4, md: 0 }} alignX="justify">
        {meterNumber && (
          <Stack.Item grow>
            <Stack gap="1">
              <Text size="BodyS">{t('meterNumberLabel')}</Text>
              <Text size="BodyM" weight="bold">
                {meterNumber}
              </Text>
            </Stack>
          </Stack.Item>
        )}

        {meterType && (
          <Stack.Item grow>
            <Stack gap="1">
              <Text size="BodyS">{t('meterTypeLabel')}</Text>
              <Text size="BodyM" weight="bold">
                {meterType}
              </Text>
            </Stack>
          </Stack.Item>
        )}

        <Stack.Item grow>
          <Stack gap="1">
            <Text size="BodyS">{t('meterValueLabel')}</Text>
            <Text size="BodyM" weight="bold">
              {meterValue}
            </Text>
          </Stack>
        </Stack.Item>
      </Stack>
    </Box>
  );
};
